import { render } from "./CmsSidebar.vue?vue&type=template&id=d595e2a6&scoped=true"
import script from "./CmsSidebar.vue?vue&type=script&lang=js"
export * from "./CmsSidebar.vue?vue&type=script&lang=js"

import "./CmsSidebar.vue?vue&type=style&index=0&id=d595e2a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d595e2a6"]])

export default __exports__